// Base
import './base/base';

// Components
import './components/header';
// import './components/menu';
import './components/form';
import './components/news';
import './components/accordion';

// Modules
import './modules/onePageNav';
import './modules/fslightbox';
import './modules/readMore';

// Lazy geladen, damit sie (inkl. GSAP/countUp-Vendor-Chunks) nicht im kritischen
// Pfad liegen und kein modulepreload erzeugen — die Effekte greifen erst beim Scrollen
import('./modules/gsap');
import('./modules/countUp');
import('./modules/elementsBlocker/elementsBlocker');

// Polyfills
import './polyfills/dialog'; // Safari <= 15.3
